import api from './api';

const chatService = {
  getConversations: (params) => api.get('/chat/conversations', { params }),
  getConversation: (id) => api.get(`/chat/conversations/${id}`),
  startConversation: (data) => api.post('/chat/start', data),
  resolveConversation: (id) => api.put(`/chat/conversations/${id}/resolve`),
  escalateConversation: (id) => api.put(`/chat/conversations/${id}/escalate`),
  getUnreadCount: () => api.get('/chat/unread-count'),
};

export default chatService;
